export function getErrorStatus(error) {
  return error?.response?.status ?? null
}

export function isHandledAuthError(error) {
  const status = getErrorStatus(error)

  return status === 400 || status === 401 || error?.isHandled === true
}

export function shouldReportToSentry(error) {
  if (!error) {
    return false
  }

  if (isHandledAuthError(error)) {
    return false
  }

  return true
}

export function isChunkLoadError(error) {
  const message = String(error?.message ?? '')

  return (
    message.includes('Failed to fetch dynamically imported module') ||
    message.includes('error loading dynamically imported module') ||
    message.includes('Unable to preload CSS') ||
    error?.name === 'ChunkLoadError'
  )
}
